import { render } from "./Capitalize.vue?vue&type=template&id=6cfbcec2"
import script from "./Capitalize.vue?vue&type=script&lang=js"
export * from "./Capitalize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__